import { FOI_FOR_FD_LOGGED_OUT_240916 } from "@faire/web-api/indigofair/settings/FOI_FOR_FD_LOGGED_OUT_240916";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const useSettingFirstOrderIncetiveForFaireDirectLoggedOut =
  (): boolean => {
    return useSetting(FOI_FOR_FD_LOGGED_OUT_240916, false);
  };

export const useAssignSettingFirstOrderIncetiveForFaireDirectLoggedOut = () => {
  return useAssignSetting(FOI_FOR_FD_LOGGED_OUT_240916);
};
